import React from 'react';
import { systemFeatures } from '../mockData';
import { Smartphone, CheckCircle } from 'lucide-react';

const SystemFeatures = () => {
  return (
    <section className="py-20 bg-[#F0F0F0]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-[#ED1C24]">Sistem Indikator SBE Keren</span>{' '}
            Buat Upgrade Level Trading Kalian
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Indikator SBE bisa bikin proses trading kalian{' '}
            <span className="text-[#ED1C24] font-bold">90% lebih cepat</span>{' '}
            dibanding ngurus semuanya sendiri!
          </p>
        </div>
        
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* SBE Mockup Image */}
            <div className="order-2 lg:order-1">
              <div className="relative max-w-lg mx-auto px-4 md:px-0">
                <div className="absolute inset-0 bg-[#ED1C24]/20 rounded-3xl blur-3xl"></div>
                <div className="relative">
                  <img 
                    src="/sbe-mockup.jpg"
                    alt="SBE Indikator Website Mockup"
                    className="w-full h-auto relative z-10 rounded-2xl shadow-2xl"
                  />
                </div>
              </div>
            </div>
            
            {/* Features List */}
            <div className="order-1 lg:order-2 space-y-8 px-4 md:px-0">
              {systemFeatures.map((feature) => (
                <div key={feature.id} className="flex items-start space-x-4 group">
                  <div className="bg-[#ED1C24] w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <CheckCircle className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-black mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SystemFeatures;